exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".container-fluid[data-v-3427be7e]{padding:0;margin:0}.appoint-detail[data-v-3427be7e]{background-color:#fcf29f;border-radius:6px}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Desktop/Sourcetree/Mariminterfood/pos_ui-Develop/src/components/alert_postponse.vue"],"names":[],"mappings":"AACA,kCACE,UAAW,AACX,QAAU,CACX,AACD,iCACE,yBAA0B,AAC1B,iBAAmB,CACpB","file":"alert_postponse.vue","sourcesContent":["\n.container-fluid[data-v-3427be7e] {\n  padding: 0;\n  margin: 0;\n}\n.appoint-detail[data-v-3427be7e] {\n  background-color: #fcf29f;\n  border-radius: 6px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3427be7e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/alert_postponse.vue
// module id = 1077
// module chunks = 1 2